import {
  InsertDriveFile as FileIcon,
  PictureAsPdf as PdfIcon,
  Description as WordIcon,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Grid, styled, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_URL_NDA } from "../../actions/EndPoints";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import store from "../../config/configureStore";
import { startLoader, stopLoader } from "../../slices/Loader/LoaderSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import DeleteLogo from "./DeleteLogo";
import NDADelete from "./NDADelete";
import { getNDADocuments } from "./NDASlice";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function EditNDA(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const history = useHistory();
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [docName1, setDocName1] = useState("");
  const [docName2, setDocName2] = useState("");
  const [document1, setDocumentName1] = useState("");
  const [document2, setDocumentName2] = useState("");
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const previousState = props.history.location.state.data;
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [data, setData] = useState([]);
  const [documentId1, setDocumentId1] = useState("");
  const [documentId2, setDocumentId2] = useState("");
  const [deleteId, setdeleteId] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [del, setDel] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    console.log("fileName1 changed:", fileName1);
    console.log("fileName2 changed:", fileName2);
  }, [fileName1, fileName2]);

  useEffect(() => {
    if (del === true) {
      setDel(false);
      if (deleteId === documentId1) {
        setDocumentId1("");
        setdeleteId(null);
      }
      if (deleteId === documentId2) {
        setDocumentId2("");
        setdeleteId(null);
      }
      loadData();
    }
  }, [del]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const [files, setFiles] = useState([
    { name: "print-final.pdf", size: "3.1 mb", status: "uploading" },
    { name: "print-final.pdf", size: "3.1 mb", status: "error" },
    { name: "print-final.doc", size: "3.1 mb", status: "done" },
  ]);

  const handleFileUpload1 = (event) => {
    const file = event.target.files?.[0];
    const size = parseInt(file?.size);
    if (size > 2 * 1024 * 1024) {
      if (fileInputRef1.current) {
        fileInputRef1.current.value = null;
      }
      Toast(t("Please upload files that are less than 2 MB."), "error");
      return;
    } else {
      setFile1(file);
      if (file) {
        setFileName1(file.name);
        setDocumentName1(file.name);
      }
    }
  };

  const handleFileUpload2 = (event) => {
    const file = event.target.files?.[0];
    const size = parseInt(file?.size);
    if (size > 2 * 1024 * 1024) {
      if (fileInputRef2.current) {
        fileInputRef2.current.value = null;
      }
      Toast(t("Please upload files that are less than 2 MB."), "error");
      return;
    } else {
      setFile2(file);
      if (file) {
        setFileName2(file.name);
        setDocumentName2(file.name);
      }
    }
  };

  const handleCancel = () => {
    history.push({
      pathname: REACT_URL_NDA,
      data: {},
    });
  };

  const handleCancle1 = () => {
    setFile1(null);
    setFileName1(docName1);
    setDocumentName1("");
    if (fileInputRef1.current) {
      fileInputRef1.current.value = null;
    }
    return;
  };
  const handleCancle2 = () => {
    setFile2(null);
    setFileName2(docName2);
    setDocumentName2("");
    if (fileInputRef2.current) {
      fileInputRef2.current.value = null;
    }
    return;
  };

  const loadData = () => {
    dispatch(getNDADocuments())
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && Array.isArray(data.data)) {
          const docs = data.data;
          setData(docs);
          setFileName1(data.data[0]?.fileName);
          setFileName2(data.data[1]?.fileName);

          setDocName1(data.data[0]?.fileName);
          setDocName2(data.data[1]?.fileName);

          setDocumentId1(data.data[0]?.id);
          setDocumentId2(data.data[1]?.id);
        } else {
          setData([]);
        }
        setDocumentName1("");
        setDocumentName2("");
      })
      .catch((err) => {
        console.error("Failed to fetch NDA documents", err);
        setData([]);
      });
  };

  const handledelete = (ids) => {
    setDiaLogBoxBlur(true);
    setdeleteId(ids);
    setOpenDelete(true);
  };

  const handleSubmit = async () => {
    if (
      (file1 || file2) &&
      ((file1 && file1.type !== "application/pdf") ||
        (file2 && file2.type !== "application/pdf"))
    ) {
      Toast(t("Please upload PDF file."), "error");
      return;
    }

    const uploadRequests = [];
    store.dispatch(startLoader());
    if (file1) {
      const upload1 = (async () => {
        try {
          const formData = new FormData();
          formData.append("documentFile", file1);
          const baseUrl = "/web/nda";
          const queryParams = `?fileName=${encodeURIComponent(
            fileName1
          )}&primaryDocument=0`;
          const documentIdPart = documentId1 ? `/${documentId1}` : "";
          const url = `${baseUrl}${documentIdPart}${queryParams}`;
          const method = documentId1 ? "put" : "post";
          const response = await axios({
            method,
            url,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("VISJwtToken"),
            },
          });
          const data = response.data;
          return data.code;
        } catch (error) {
          console.error("Failed to upload file 1:", error.message);
          alert("Failed to upload file 1: " + error.message);
          return null;
        }
      })();
      uploadRequests.push(upload1);
    }

    if (file2) {
      const upload2 = (async () => {
        try {
          const formData = new FormData();
          formData.append("documentFile", file2);
          const baseUrl = "/web/nda";
          const queryParams = `?fileName=${encodeURIComponent(
            fileName2
          )}&primaryDocument=1`;
          const documentIdPart = documentId2 ? `/${documentId2}` : "";
          const url = `${baseUrl}${documentIdPart}${queryParams}`;
          const method = documentId2 ? "put" : "post";
          const response = await axios({
            method,
            url,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("VISJwtToken"),
            },
          });
          const data = response.data;
          return data.code;
        } catch (error) {
          console.error("Failed to upload file 2:", error.message);
          alert("Failed to upload file 2: " + error.message);
          return null;
        }
      })();
      uploadRequests.push(upload2);
    }

    const results = await Promise.allSettled(uploadRequests);
    store.dispatch(stopLoader());
    const successFound = results.some(
      (res) =>
        (res.status == "fulfilled" && res.value == "MSGS4089") ||
        (res.status == "fulfilled" && res.value == "MSGS4088")
    );
    if (file1 || file2) {
      if (successFound) {
        Toast(t("NDA document(s) uploaded successfully."), "success");
      } else {
        Toast("Something went wrong", "error");
      }
    } else {
      Toast(t("NDA document(s) uploaded successfully."), "success");
    }
    // loadData();
    handleCancel();
  };

  const getFileIcon = (fileName) => {
    if (fileName.endsWith(".pdf"))
      return <PdfIcon style={{ color: "#f40f02" }} />;
    if (fileName.endsWith(".doc") || fileName.endsWith(".docx"))
      return <WordIcon style={{ color: "#2b579a" }} />;
    return <FileIcon />;
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid style={{ display: "flex", cursor: "pointer" }}>
          <Box>
            <HeaderToolbar title={t("Edit NDA")} back_button={true} />
          </Box>
        </Grid>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 160px)",
          backgroundColor: darkMode ? "#0E2A41" : "white",
          overflow: "auto",
          paddingTop: "1px",
          borderRadius: "8px",
        }}
      >
        <Box
          style={{
            display: "flex",
            padding: "40px 60px 30px 60px",
            gap: "25px",
          }}
        >
          <Grid
            item
            sm={6}
            xs={12}
            style={{
              width: "100%",
              height: "100%",
              paddingBottom: "15px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: darkMode ? "#1b3245" : "#f5f5f5e6",
              opacity: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              pt={3}
              style={{
                color: darkMode ? "white" : "#000000",
                opacity: "0.8",
                fontFamily: "normal normal bold 24px/29px Roboto",
              }}
            >
              Document Upload
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              gutterBottom
              style={{
                color: darkMode ? "white" : "#000000",
                opacity: "0.6",
                fontFamily: "normal normal normal 20px/24px Roboto",
              }}
            >
              Select and upload your file.
            </Typography>
            <div
              style={{
                border: "2px dashed #c4e3f0cc",
                borderRadius: "8px",
                padding: "24px",
                textAlign: "center",
                width: "230px",
                marginTop: "20px",
                marginBottom: "15px",
              }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                if (e.dataTransfer.files[0]) {
                  handleFileUpload1(e.dataTransfer.files[0]);
                }
              }}
            >
              <Typography
                variant="body2"
                style={{
                  color: "grey",
                  marginBottom: "30px",
                  color: darkMode ? "white" : "#000000",
                  opacity: "0.8",
                  fontFamily: "normal normal normal 24px/32px Roboto",
                }}
              >
                Choose a PDF file to upload
              </Typography>

              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
              >
                <Button
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    backgroundColor: "#f37c34",
                    borderRadius: "40px !important",
                    width: "150px",
                    height: "40px",
                    color: "white",
                    fontFamily: "normal normal medium 16px/19px Roboto"
                  }}
                >
                  <Typography>Browse file</Typography>
                  <VisuallyHiddenInput
                    type="file"
                    accept="application/pdf,.pdf"
                    onChange={handleFileUpload1}
                    ref={fileInputRef1}
                  />
                </Button>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                    minHeight: '24px', // Reserve space so layout doesn't shift
                    opacity: fileName1 ? 1 : 0,
                    visibility: fileName1 ? 'visible' : 'hidden',
                    transition: 'opacity 0.3s ease',
                  }}
                >
                  <Tooltip title={fileName1}>
                    <Typography
                      style={{
                        color: "#0F5A9C",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px",
                        opacity: 1,
                        fontFamily: "normal normal normal 20px/24px Roboto",
                      }}
                    >
                      {fileName1}
                    </Typography>
                  </Tooltip>
                  {document1 ? (
                    <Tooltip title="Close">
                      <CloseIcon
                        onClick={() => {
                          handleCancle1();
                        }}
                        style={{
                          cursor: 'pointer',
                          fontSize: '18px',
                          borderRadius: '50%',
                          padding: '3px',
                          backgroundColor: '#FF5630',
                          width: '18px',
                          height: '18px',
                          color: "white",
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Box
                      onClick={() => {
                        handledelete(documentId1);
                        setFileName1("");
                      }}
                    >
                      <DeleteLogo />
                    </Box>
                  )}
                </Box>
              </Box>
            </div>
          </Grid>

          <Grid
            item
            sm={6}
            xs={12}
            style={{
              width: "100%",
              height: "100%",
              paddingBottom: "15px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: darkMode ? "#1b3245" : "#f5f5f5e6",
              opacity: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              pt={3}
              style={{
                color: darkMode ? "white" : "#000000",
                opacity: "0.8",
                fontFamily: "normal normal bold 24px/29px Roboto",
              }}
            >
              Document Upload
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              gutterBottom
              style={{
                color: darkMode ? "white" : "#000000",
                opacity: "0.6",
                fontFamily: "normal normal normal 20px/24px Roboto",
              }}
            >
              Select and upload your file.
            </Typography>

            <div
              style={{
                border: "2px dashed #c4e3f0cc",
                borderRadius: "8px",
                padding: "24px",
                textAlign: "center",
                width: "230px",
                marginTop: "20px",
                marginBottom: "15px",
              }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                if (e.dataTransfer.files[0]) {
                  handleFileUpload2(e.dataTransfer.files[0]);
                }
              }}
            >
              <Typography
                variant="body2"
                style={{
                  color: "grey",
                  marginBottom: "30px",
                  color: darkMode ? "white" : "#000000",
                  opacity: "0.8",
                  fontFamily: "normal normal normal 24px/32px Roboto",
                }}
              >
                Choose a PDF file to upload
              </Typography>

              <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                <Button
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    backgroundColor: "#f37c34",
                    borderRadius: "40px !important",
                    width: "150px",
                    height: "40px",
                    color: "white",
                    fontFamily: "normal normal medium 16px/19px Roboto"
                  }}
                >
                  <Typography>Browse file</Typography>

                  <VisuallyHiddenInput
                    type="file"
                    onChange={handleFileUpload2}
                    accept="application/pdf,.pdf"
                    ref={fileInputRef2}
                  />
                </Button>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                    minHeight: '24px', // fixed height
                    opacity: fileName2 ? 1 : 0,
                    visibility: fileName2 ? "visible" : "hidden",
                    transition: "opacity 0.3s ease",
                  }}
                >
                  <Tooltip title={fileName2}>
                    <Typography
                      style={{
                        color: "#0F5A9C",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px",
                        opacity: 1,
                        fontFamily: "normal normal normal 20px/24px Roboto",
                      }}
                    >
                      {fileName2}
                    </Typography>
                  </Tooltip>

                  {document2 ? (
                    <Tooltip title="Close">
                      <CloseIcon
                        onClick={() => {
                          handleCancle2();
                        }}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                          borderRadius: "50%",
                          padding: "3px",
                          backgroundColor: "#FF5630",
                          width: "18px",
                          height: "18px",
                          color: "white",
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Box
                      onClick={() => {
                        handledelete(documentId2);
                        setFileName2("");
                      }}
                    >
                      <DeleteLogo />
                    </Box>
                  )}
                </Box>
              </Box>
            </div>
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            width: "100%",
            paddingRight: "60px",
            paddingBottom: "30px"
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={handleCancel}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("INVITATION003")}
            </Typography>
          </CancelButtons>

          <SubmitButtons variant="contained" onClick={handleSubmit}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON035")}
            </Typography>
          </SubmitButtons>
        </Box>
      </Box >
      {openDelete && (
        <NDADelete
          open={openDelete}
          handleClose={(data) => {
            setOpenDelete(data);
            setDiaLogBoxBlur(false);
            if (deleteId === documentId1) {
              setDocumentId1("");
              setdeleteId(null);
            }
            if (deleteId === documentId2) {
              setDocumentId2("");
              setdeleteId(null);
            }
            loadData();
          }}
          deleteId={deleteId}
          delete={() => setDel(true)}
        />
      )}
    </>
  );
}
export default EditNDA;
